import { HttpStatusCode } from "axios";

import { alertConstants } from "../../helper/sweet-alert";
import StudentHelpService from "../../apiServices/masters/studentHelpService";
import { setStudentHelp, setStudentHelps } from "../../store/slices/master/studentHelpSlice";

export function getStudentHelp(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await StudentHelpService.getStudentHelp(id);
    if (response?.success === true) {
      dispatch(setStudentHelp(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getStudentHelps(configUserRole?: number) {
  return async function (dispatch: any, getState: any) {
    let response = await StudentHelpService.getStudentHelps(configUserRole);
    if (response?.success === true) {
      dispatch(setStudentHelps(response.data));
    } else {
      console.log("error");
    }
  };
}

export function createStudentHelp(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await StudentHelpService.createStudentHelp(data);
    const name = data.get("title")
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict, name);
      }
      else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateStudentHelp(data: any, id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await StudentHelpService.updateStudentHelp(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}
export function updateStudentHelpPriority(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await StudentHelpService.updateStudentHelpPriority(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      callback(alertConstants.error);
    }
  };
}
export function deleteStudentHelp(id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await StudentHelpService.deleteStudentHelp(id);
    if (response === true) {
      callback(alertConstants.inactiveSuccess);
    } else {
      callback(alertConstants.inactiveFailure);
    }
  };
}
